const CODE = {
    CODE_BOARDING: "BOARDING", // boarding
    CODE_CC_PROCESSING: "CC_PROCESSING", // authorize.net credit card
    CC_PROCESSING_PRICE: 10,
    CODE_WELLNESS: "WELLNESS", // wellness plan
    CODE_ANTECH: "ANTECH", // antech
    CODE_ANTECH_WEST: "ANTECH_WEST", // antech
    CODE_ANTECH_EAST: "ANTECH_EAST", // antech
    CODE_ABAXIS_API: "ABAXIS_API", // abaxis api , zoetis-vetsync
    CODE_ALLY_DVM: "ALLY_DVM", // allyDVM
    CODE_VETSTORIA: "VETSTORIA", // Vetstoria
    CODE_VITUSVET: "VITUSVET", // VitusVet
    CODE_ONPREM: "ONPREM", // onprem
    CODE_ONPREM_ABAXIS: "Abaxis", // onprem
    CODE_ONPREM_HESKA: "Heska", // onprem
    CODE_ONPREM_HESKA_UPPERCASE: "HESKA", // onprem
    CODE_CLOUD_PRINT: "CLOUD_PRINT", //cloud printer
    CODE_MWI: "MWI", // catalog
    CODE_VICTOR: "VICTOR", // catalog
    CODE_ESHELF: "ESHELF", // catalog
    CODE_FAXING: "FAXING", // faxing
    LIFE_LEARN: "LIFE_LEARN", // life learn
    CODE_ANIMAL_REFERENCE_PATHOLOGY: "ANIMAL_REFERENCE_PATHOLOGY", // ligo lab
    CODE_SMS: "SMS", // sms
    CODE_TIME_CLOCK: "TIME_CLOCK", // time clock
    CODE_API: "API", // api
    CODE_EPET: "EPET", // epet
    CODE_STRIPE: "STRIPE",
    CODE_ANET: "ANET",
    CODE_DICOM: "DICOM",
    CODE_DFORCE_API: "DFORCE_API", // demandforce api
    CODE_PAWPRINT_API: "PAWPRINT_API", // pawprint app and reminders
    CODE_PAWPRINT_APP: "PAWPRINT_APP", // pawprint api
    CODE_CCONNECT: "CCONNECT",
    CODE_QUICKBOOKS: "QUICKBOOKS",
    CODE_NEXTINLINE: "NEXTINLINE",
    CODE_ONSCHEDULE: "ONSCHEDULE",
    CODE_IDEXX: "IDEXX",
    CODE_ASTERIS: "ASTERIS",
    CODE_ZNLABS: "ZNLABS",
    CODE_NBIOVET: "NBIOVET",
    CODE_MIDWEST: "MIDWEST",
    CODE_VETEK: "VETEK",
    CODE_MICROVET: "MICROVET",
    CODE_BIONOTE: "BIONOTE",
    CODE_TRUPANION: "TRUPANION",
    CODE_TREATMENT_BOARD: "TREATMENT_BOARD",
    CODE_IDEXX_DR: "IDEXX_DR",
    CODE_GREENLINE: "GREENLINE",
    CODE_HOME_AGAIN: "HOME_AGAIN",
    CODE_PETLINK: "PETLINK",
    CODE_PETDESK: "PETDESK",
    CODE_ABAXIS_FUSE: "ABAXIS_FUSE", // zoetis fuse
    CODE_GRAVITY: "GRAVITY",
    CODE_ZOETIS: "Zoetis",
    CODE_VETTER_PRINTER: "VETTER_PRINTER",
    CODE_BIVVY: "BIVVY",
    CODE_PREVISIT: "PREVISIT",
    CODE_SNOUTID: "SNOUTID",
    CODE_MICHELSON_FOUND_ANIMALS: "MICHELSON_FOUND_ANIMALS",
    CODE_VETCOVE: "VETCOVE",
    CODE_HESKA_CLOUD: "HESKA_CLOUD",
    CODE_SOUNDPACS: "SOUNDPACS",
    CODE_2_WAY_MESSAGING: "2_WAY_MESSAGING",
    CODE_VRS: "VRS",
    CODE_WEAVE: "WEAVE",
    CODE_AUTOREMIND: "AUTOREMIND",
    INTEGRATED_PAYMENTS: "INTEGRATED_PAYMENTS",
    CODE_VETOLOGY: "VETOLOGY",
    CODE_CLIENT_MOBILE_APP: "CLIENT_MOBILE_APP",
    CODE_VETSNAP: "VETSNAP",
    CODE_CUSTOM_REPORT: "CUSTOM_REPORT",
    CODE_IDEXX_DEVICE: "IDEXX_DEVICE",
    CODE_OTHER: "OTHER",
    CODE_VETSOURCE: "VETSOURCE",
    CODE_VETCOVE_ONLINE: "VETCOVE_ONLINE",
    CODE_CUBEX: "CUBEX"
};

const STATUS = {
    STATUS_DISABLED: "DISABLED",
    STATUS_ENABLED: "ENABLED",
    STATUS_PENDING: "PENDING",
    STATUS_VERIFIED: "VERIFIED"
};

export default {
    CODE,
    STATUS
};
